<ng-container *ngIf="loadingService.enabled">
    <div class="loading" *ngIf="loadingService.loading">
        <div class="loading__background"></div>
        <div class="loading__icon"></div>
    </div>
</ng-container>
